export const ACTUALIZAR_LIST_PELIGRO = "ACTUALIZAR_LIST_PELIGRO";
export const MODIFICAR_PELIGRO = "MODIFICAR_PELIGRO";
export const AGREGAR_PELIGRO = "AGREGAR_PELIGRO";
export const ELIMINAR_PELIGRO = "ELIMINAR_PELIGRO";
